export enum MenuItemType {
  SIMPLE = "simple",
  WITH_SUBITEMS = "with_subitems",
  QUICK_LINKS = "quick_links",
}

export const MENU_STYLES = {
  menuButton: {
    base: "text-gray-800 transition-all duration-200",
    collapsed: "mx-auto h-10 w-10 justify-center p-0",
    expanded: "hover:translate-x-0.5",
    hover: "hover:bg-gray-50/80",
  },
  icon: {
    base: "transition-transform duration-200",
    main: "!h-5 !w-5",
    sub: "h-3.5 w-3.5",
    nested: "h-2.5 w-2.5",
  },
  dropdown: {
    content: "w-64 border p-1 shadow-lg duration-200 animate-in slide-in-from-left-2",
    item: "cursor-pointer gap-3 px-3 py-2 transition-colors duration-150 hover:bg-gray-50/50",
    header: "border-b px-3 py-2 text-sm font-medium text-gray-900",
  },
  submenu: {
    base: "ml-2 transition-all duration-200 hover:translate-x-0.5 hover:bg-gray-50/50",
    nested: " transition-all duration-200 hover:translate-x-0.5 hover:bg-gray-50/50",
    text: "text-gray-600 hover:text-gray-900",
    nestedText: " text-gray-500 hover:text-gray-900",
  },
  accordion: {
    trigger: "w-full justify-between transition-all duration-200 hover:bg-gray-50/50",
    expandButton:
      "rounded-md p-1 opacity-0 transition-all duration-200 hover:bg-gray-100/80 group-hover/menu:opacity-100",
  },
} as const;

export const ICON_CONTAINER_STYLES = {
  main: "flex h-4 w-4 items-center justify-center opacity-70",
  nested: "flex h-3 w-3 items-center justify-center opacity-60",
} as const;

export const TEXT_STYLES = {
  active: "font-medium text-gray-900",
  inactive: "text-gray-600 hover:text-gray-900",
  nestedInactive: "text-gray-500 hover:text-gray-700",
} as const;
